import { useEffect } from "react";
import { SITE_URL } from "@/seo/seoConfig";

const DEFAULT_ROBOTS = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const SeoHead = ({ title, description, path = "/", noindex = false }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, nofollow" : DEFAULT_ROBOTS });
    upsert('link[rel="canonical"]', { rel: "canonical", href: url });
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
    upsert('meta[property="og:title"]', { property: "og:title", content: title });
    upsert('meta[property="og:description"]', { property: "og:description", content: description });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    if (path !== "/") document.head.querySelectorAll("link[hreflang]").forEach((el) => el.remove());
  }, [title, description, path, noindex]);
  return null;
};

export default SeoHead;
